import { render, staticRenderFns } from "./public-address-save.vue?vue&type=template&id=62dcea2e"
import script from "./public-address-save.vue?vue&type=script&lang=js"
export * from "./public-address-save.vue?vue&type=script&lang=js"
import style0 from "./public-address-save.vue?vue&type=style&index=0&id=62dcea2e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports